import { AsyncPipe } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DestroyRef,
    inject,
    OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AppShellComponentType, AppShellModule, HelpInfoService } from '@priva/appshell';
import { DynamicComponent, PrivaDynamicModule } from '@priva/components/dynamic';

import { selectActiveDialogs } from 'app/state/app-state/app-state.selectors';
import { loadMasterDataFromServer } from 'app/state/master-data/master-data.actions';

import { UserSessionInfoComponent } from '../user-session-info/user-session-info.component';

@Component({
    selector: 'app-main',
    templateUrl: './app-main.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, AppShellModule, PrivaDynamicModule, UserSessionInfoComponent],
})
export class AppMainComponent implements OnInit {
    private store = inject(Store);
    private cdr = inject(ChangeDetectorRef);
    private destroyRef = inject(DestroyRef);
    private helpService = inject(HelpInfoService);
    activeDialogs$: Observable<DynamicComponent[]>;

    constructor() {
        this.activeDialogs$ = this.store.select(selectActiveDialogs);
    }

    handleClick(type: AppShellComponentType) {
        if (type === AppShellComponentType.AppHelp) {
            this.store.dispatch(loadMasterDataFromServer());
        }
    }

    ngOnInit() {
        this.helpService.helpInfo
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => this.cdr.detectChanges());
    }
}
